import { _ } from "libs";
import React, { FC, memo, useContext, useEffect, useState } from "react";
import { Championship } from "../../types";
import { getChampionshipTournaments } from "../../actions";
import Loader from "../loader";
import ChampionshipContext from "../../contexts/championshipContext";
import { NavLink } from "react-router-dom";
import moment from "moment";
import cx from "classnames";

const LinkedTournaments: FC = () => {
	const { championship } = useContext(ChampionshipContext);

	const [tournaments, setTournaments] = useState(null as Championship[]);
	const [loading, setLoading] = useState(true);
	const [showExtraTournaments, setShowExtraTournaments] = useState(false);

	const reloadTournaments = async () => {
		const tournaments = await getChampionshipTournaments(championship.uuid);
		setTournaments(tournaments);
	};

	const toggleExtraTournaments = () => {
		setShowExtraTournaments(!showExtraTournaments);
	};

	useEffect(() => {
		let unmounted = false;

		if (!unmounted) {
			if (championship) {
				setLoading(true);
				reloadTournaments();
				setLoading(false);
			}
		}

		return () => {
			unmounted = true;
		};
	}, [championship]);

	if (tournaments?.length === 0) return;

	return (
		<>
			{championship && tournaments && (
				<div className="nBlock">
					<h5>{_("championship.tournaments.heading")}</h5>
					{!loading && tournaments?.length > 0 && (
						<div className="tournaments cards" id="tournamentsList">
							{tournaments.map((tournament, i) => {
								let seatsLeft = tournament.settings.maxParticipants - tournament.players;
								let isRegistered = tournament.optedIn;
								let tag;
								if (isRegistered) {
									tag = <div className="tag green">{_("championship.tournament.registered")}</div>;
								} else if (seatsLeft === 0) {
									tag = <div className="tag grey">{_("championship.tournament.soldOut")}</div>;
								} else if (tournament.settings?.optInDeadline && tournament.settings.optInDeadline < (Date.now() / 1000)) {
									tag = <div className="tag grey">{_("championship.tournament.closed")}</div>;
								} else {
									tag = (
										<div className="tag orange">
											{_("championship.tournament.seatsLeft", seatsLeft, {
												seatsLeft: seatsLeft,
											})}
										</div>
									);
								}
								return (
									<NavLink
										to={"/championship/" + tournament.uuid}
										key={tournament.uuid}
										className={cx("tournament", "card", {
											hidden: i > 3 && showExtraTournaments === false,
										})}
									>
										<div className={cx("item", "tournament", "medium")}>
											<div
												className="itemImage"
												style={{ backgroundImage: `url(${tournament.settings.pictureUrl})` }}
											></div>
											<div className="itemExtra">{tag}</div>
											<div className="itemBody">
												<div className="title">{tournament.name}</div>
												<div className="meta">
													{moment.unix(tournament.startDateTime).format("ddd, MMMM D")}
												</div>
											</div>
										</div>
									</NavLink>
								);
							})}
						</div>
					)}
					{tournaments?.length > 4 ? (
						<div className="mt-3">
							<span className="link" onClick={toggleExtraTournaments}>
								{showExtraTournaments ? _("showLessBtn") : _("showMoreBtn")}
							</span>
						</div>
					) : null}
				</div>
			)}
			{loading && <Loader notext={true} />}
		</>
	);
};

export default memo(LinkedTournaments);
